import SkeletonLoader from "./skeleton_loader";

const ImageLoader = ({src, imgClass, alt, width, height, skelWidth, skelHeight}) => {
    let imageClass= new Image();
    const renderImageUrl = catalogModule.getUrl("static_na_product");
    const [isLoadingImg, setIsLoadingImg] = React.useState(false);
    const [hasImage, setHasImage] = React.useState(false);
    let imgRef = React.useRef(null);
    function imageFound() {
        setIsLoadingImg(false);
        setHasImage(true);
    }

    function imageNotFound() {
        setIsLoadingImg(false);
    }

    function checkImage(url){
        setIsLoadingImg(true);
        // imageClass.alt = alt;
        // imageClass.width = width;
        // imageClass.height = height;
        // imageClass.className = imgClass;
        if(imgRef && imgRef.current){
            // imgRef.current.addEventListener('load', imageFound);
        }
        if(imageClass){
            imageClass.onload = imageFound;
            imageClass.onerror = imageNotFound;
        } else {
        //     imageClass.addEventListener('load', imageFound);
        //     imageClass.addEventListener('error', imageNotFound);
        }
        imageClass.src = url;
    }

    React.useEffect(() => {
        checkImage(src);
        return () => {
            if(imageClass){
                imageClass.onload = null;
                imageClass.onerror = null;
            //     imageClass.removeEventListener('load', imageFound);
            //     imageClass.removeEventListener('error', imageNotFound);
            }
            if(imgRef && imgRef.current){
                // imgRef.current.removeListener('load', imageFound);
                imgRef.current = null;
            }
        }
    }, []);
    return (
        <React.Fragment>
            { isLoadingImg && <SkeletonLoader width={skelWidth ? skelWidth : '128px'} height={skelHeight ? skelHeight : '130px'}/> }
            { !isLoadingImg && !hasImage && <img src={renderImageUrl}
                                                 className={imgClass}
                                                 alt={alt}
                                                 width={width}
                                                 height={height} />}
            {!isLoadingImg && hasImage && <img src={src}
                                               className={imgClass}
                                               alt={alt}
                                               width={width}
                                               height={height} />}
        </React.Fragment>
    )
}

export default ImageLoader;
